module.exports = __webpack_public_path__ + "img/hours.04aaf978.svg";